<template>
  <Modal :toggle="toggle">
    <div class="modal-service">
      <div class="qr-wraper">
        <img class="qrcode" :src="qrcode" />
      </div>
      <div class="desc">{{ desc }}</div>
      <img src="../assets/icon-close.svg" class="close-icon" @click="$emit('close')" />
    </div>
  </Modal>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import Modal from '@/components/Modal';
@Component({
  components: {
    Modal,
  },
})
export default class ModalService extends Vue {
  @Prop(Boolean) toggle!: boolean;
  @Prop(String) qrcode!: string;
  @Prop(String) desc!: string;
}
</script>

<style lang="scss" scoped>
$content-color: #9d9db5;
.modal-service {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 580px;
  min-height: 732px;
  padding-top: 80px;
  background-color: #ffffff;
  border-radius: 24px;
  .qr-wraper {
    box-sizing: border-box;
    width: 415px;
    height: 415px;
    padding: 27px;
    background: #f3f2f6;
    border-radius: 24px;
    .qrcode {
      width: 100%;
      height: 100%;
    }
  }
  .desc {
    width: 432px;
    margin-top: 32px;
    color: $content-color;
    font-weight: normal;
    font-size: 30px;
    line-height: 1.5;
  }
  .close-icon {
    position: absolute;
    bottom: -64px;
    left: 50%;
    width: 70px;
    height: 72px;
    transform: translate(-50%, 100%);
  }
}
</style>
